import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";

import { Chart, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Filler, Legend, } from "chart.js";


import {
  saleRevenue,
  activeSubscription,
  salesOverview,
  coinOverview,
  coinOverviewSet1,
  coinOverviewSet2,
  coinOverviewSet3,
  userActivity,
  orderOverviewSet1,
  orderOverviewSet2,
  orderOverviewSet3,
  userActivitySet2,
  userActivitySet3,
  userActivitySet4,
} from "./Data";
Chart.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Filler, Legend,);
export const BarChart = ({ sales }) => {
  return (
    <Bar
      className="sales-bar-chart chartjs-render-monitor"
      data={sales ? saleRevenue : activeSubscription}
      options={{
        plugins: {
          legend: {
              display: false,
          },
          tooltip: {
              enabled: true,
              displayColors: false,
              backgroundColor: "#eff6ff",
              titleFont: {
                size: '11px',
              },
              titleColor: "#6783b8",
              titleMarginBottom: 4,
              bodyColor: "#9eaecf",
              bodyFont: {
                size: '10px',
              },
              bodySpacing: 3,
              padding: 8,
              footerMarginTop: 0,
          },
        },
        scales: {
          y:{
              display: false,
          },
          x:{
              display: false,
          },
        },
        maintainAspectRatio: false,
      }}
    />
  );
};

const formatSecondsToHHMMSS = (seconds) => {
    const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${h}:${m}:${s}`;
};

export const LineChart = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0] + ":00"),
                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};


export const LineChart6 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0]),
                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};

export const LineChart66 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0].split("-")[2]),

                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};

export const LineChart6666 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => {
                    const [year, month] = item[0].split("-");
                    const monthNames = [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                    ];
                    return `${year}-${monthNames[parseInt(month) - 1]}`;
                }),



                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};
export const LineChart67 = ({ chartData }) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Extract month labels and corresponding values
    const labels = chartData.map(item => monthNames[item[0] - 1] || `Month ${item[0]}`);
    const values = chartData.map(item => item[1]);

    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels,
                datasets: [
                    {
                        label: "Visitors",
                        data: values,
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};


export const LineChart3 = ({
                               data1,
                               data2,
                               label1,
                               label2,
                               color1 = "#4b7bec",
                               color2 = "#f97316"
                           }) => {
    // Combine all hours (x-axis) from both datasets
    const allHoursSet = new Set([
        ...data1.map((item) => item[0]),
        ...data2.map((item) => item[0]),
    ]);
    const allHours = Array.from(allHoursSet).sort((a, b) => a - b);

    // Map for quick value lookup
    const data1Map = Object.fromEntries(data1);
    const data2Map = Object.fromEntries(data2);

    // Prepare final data arrays
    const labels = allHours.map((hour) => `${hour}:00`);
    const values1 = allHours.map((hour) => data1Map[hour] ?? 0);
    const values2 = allHours.map((hour) => data2Map[hour] ?? 0);

    const total1 = `${values2.reduce((a, b) => a + b, 0)}`;
    const total2 = `${values1.reduce((a, b) => a + b, 0)}`;

    const chartData = {
        labels,
            datasets: [
                {
                    label: `${label1} `,
                    data: values1,
                    fill: false,
                    borderColor: color2,
                    backgroundColor: color2,
                    tension: 0.4,
                    borderDash: [5, 5],
                    borderWidth: 2,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                    pointBackgroundColor: "#fff",
                    pointBorderColor: color2,
                },
                {
                    label: `${label2} `,
                    data: values2,
                    fill: true,
                    borderColor: color1,
                    backgroundColor: `${color1}33`,
                    tension: 0.4,
                    borderDash: [],
                    borderWidth: 2,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                    pointBackgroundColor: "#fff",
                    pointBorderColor: color1,
                },
            ],

    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "top",
                labels: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
            },
            tooltip: {
                enabled: true,
                displayColors: false,
                backgroundColor: "#eff6ff",
                titleFont: { size: 13 },
                titleColor: "#6783b8",
                bodyColor: "#9eaecf",
                bodyFont: { size: 12 },
                bodySpacing: 4,
                padding: 10,
                callbacks: {
                    label: function (context) {
                        return `${context.parsed.y} Visitors`;
                    },
                },
            },
        },
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    font: { size: 11 },
                    padding: 8,
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
            x: {
                ticks: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
                grid: {
                    color: "transparent",
                },
            },
        },
    };

    return (


        // <Line className="sales-overview-chart" data={chartData} options={chartOptions} />

        <div>
            {/* Totals above the chart */}
            <div style={{display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "1rem"}}>
                <div>
                    <span style={{color: color2, fontWeight: "bold"}}>●</span> Total: {total2}
                </div>
                <div>
                    <span style={{color: color1, fontWeight: "bold"}}>●</span> Total: {total1}
                </div>
            </div>

            {/* Chart container */}
            <div className="nk-sales-ck large mb-lg-4 pt-2 " style={{maxHeight: "400px", overflow: "auto"}}>

                <Line data={chartData} options={chartOptions}/>
            </div>
        </div>

    );
};


export const LineChart8 = ({
                               data1,
                               data2,
                               color1 = "#4b7bec",
                               color2 = "#f97316",
                           }) => {
    const maxLength = Math.max(data1.length, data2.length);

    // Helper to get weekday name from date string
    const getDayName = (dateStr) => {
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-US", {weekday: "long"});
    };

    // Generate labels
    const labels = Array.from({length: maxLength}, (_, i) => {
        const label1 = getDayName(data1[i]?.[0]);
        const label2 = getDayName(data2[i]?.[0]);
        return label1 === label2 ? label1 : `${label1} / ${label2}`;
    });

    // Values and totals
    const values1 = Array.from({ length: maxLength }, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({ length: maxLength }, (_, i) => data2[i]?.[1] ?? null);

    const total1 = values1.reduce((sum, val) => sum + (val || 0), 0);
    const total2 = values2.reduce((sum, val) => sum + (val || 0), 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: `${data1[0]?.[0] || ""} - ${data1[data1.length - 1]?.[0] || ""}`,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: `${data2[0]?.[0] || ""} - ${data2[data2.length - 1]?.[0] || ""}`,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";
                        return `${getDayName(date)} (${date}): ${value}`;
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: { size: 10 },
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
            },
        },
    };

    return (
        <div>
            {/* Totals above the chart */}
            <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "1rem" }}>
                <div>
                    <span style={{ color: color1, fontWeight: "bold" }}>●</span> Total: {total1}
                </div>
                <div>
                    <span style={{ color: color2, fontWeight: "bold" }}>●</span> Total: {total2}
                </div>
            </div>

            {/* Chart container */}
            <div style={{ height: "250px" }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};



export const LineChart9 = ({
                               data1,
                               data2,
                               color1 = "#4b7bec",
                               color2 = "#f97316",
                           }) => {
    const maxLength = Math.max(data1.length, data2.length);

    // Helper to get weekday name from date string
    const getDayName = (dateStr) => {
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-US", { weekday: "long" });
    };

    // Generate labels
    const labels = Array.from({ length: maxLength }, (_, i) => {
        const label1 = getDayName(data1[i]?.[0]);
        const label2 = getDayName(data2[i]?.[0]);
        return label1 === label2 ? label1 : `${label1} / ${label2}`;
    });

    const values1 = Array.from({length: maxLength}, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({length: maxLength}, (_, i) => data2[i]?.[1] ?? null);

    const label1 =
        data1.length > 0 ? `${data1[0][0]} - ${data1[data1.length - 1][0]}` : "Dataset 1";
    const label2 =
        data2.length > 0 ? `${data2[0][0]} - ${data2[data2.length - 1][0]}` : "Dataset 2";

    const chartData = {
        labels,
        datasets: [
            {
                label: label1,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: label2,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {

                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";

                        const seconds = context.parsed.y;
                        const formattedTime = formatSecondsToHHMMSS(seconds);
                        return `${date}: ${formattedTime}`;
                    },
                },
            },
            maintainAspectRatio: false,
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: {size: 10},
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    callback: (value) => formatSecondsToHHMMSS(value),
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
        },
    };

    return <div style={{height: "250px"}}>
        <Line data={chartData} options={chartOptions}/>
    </div>
};

export const LineChart88 = ({
                               data1,
                               data2,
                               color1 = "#4b7bec",
                               color2 = "#f97316",
                           }) => {
    const maxLength = Math.max(data1.length, data2.length);

    // Helper to get weekday name from date string
    // ✅ New - show only date like "06"
    const getDateOnly = (dateStr) => {
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : date.getDate().toString().padStart(2, "0");
    };


    // Generate labels
    const labels = Array.from({ length: maxLength }, (_, i) => {
        const label1 = getDateOnly(data1[i]?.[0]);
        const label2 = getDateOnly(data2[i]?.[0]);
        return label1 === label2 ? label1 : `${label1} / ${label2}`;
    });


    // Values and totals
    const values1 = Array.from({ length: maxLength }, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({ length: maxLength }, (_, i) => data2[i]?.[1] ?? null);

    const total1 = values1.reduce((sum, val) => sum + (val || 0), 0);
    const total2 = values2.reduce((sum, val) => sum + (val || 0), 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: `${data1[0]?.[0] || ""} - ${data1[data1.length - 1]?.[0] || ""}`,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: `${data2[0]?.[0] || ""} - ${data2[data2.length - 1]?.[0] || ""}`,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";
                        return `${getDateOnly(date)} (${date}): ${value}`;
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: { size: 10 },
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
            },
        },
    };

    return (
        <div>
            {/* Totals above the chart */}
            <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "1rem" }}>
                <div>
                    <span style={{ color: color1, fontWeight: "bold" }}>●</span> Total: {total1}
                </div>
                <div>
                    <span style={{ color: color2, fontWeight: "bold" }}>●</span> Total: {total2}
                </div>
            </div>

            {/* Chart container */}
            <div style={{ height: "250px" }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};



export const LineChart99 = ({
                               data1,
                               data2,
                               color1 = "#4b7bec",
                               color2 = "#f97316",
                           }) => {
    const maxLength = Math.max(data1.length, data2.length);

    // Helper to get weekday name from date string
// ✅ New - show only date like "06"
    const getDateOnly = (dateStr) => {
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : date.getDate().toString().padStart(2, "0");
    };


    // Generate labels
    const labels = Array.from({ length: maxLength }, (_, i) => {
        const label1 = getDateOnly(data1[i]?.[0]);
        const label2 = getDateOnly(data2[i]?.[0]);
        return label1 === label2 ? label1 : `${label1} / ${label2}`;
    });


    const values1 = Array.from({length: maxLength}, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({length: maxLength}, (_, i) => data2[i]?.[1] ?? null);

    const label1 =
        data1.length > 0 ? `${data1[0][0]} - ${data1[data1.length - 1][0]}` : "Dataset 1";
    const label2 =
        data2.length > 0 ? `${data2[0][0]} - ${data2[data2.length - 1][0]}` : "Dataset 2";

    const chartData = {
        labels,
        datasets: [
            {
                label: label1,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: label2,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {

                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";

                        const seconds = context.parsed.y;
                        const formattedTime = formatSecondsToHHMMSS(seconds);
                        return `${date}: ${formattedTime}`;
                    },
                },
            },
            maintainAspectRatio: false,
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: {size: 10},
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    callback: (value) => formatSecondsToHHMMSS(value),
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
        },
    };

    return <div style={{height: "250px"}}>
        <Line data={chartData} options={chartOptions}/>
    </div>
};


export const LineChart888 = ({
                                data1,
                                data2,
                                 year1,
                                 year2,
                                color1 = "#4b7bec",
                                color2 = "#f97316",
                            }) => {
    const maxLength = Math.max(data1.length, data2.length);


    // Helper to get weekday name from date string
// ✅ New - show only date like "06"
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Extract month labels and corresponding values
    const labels = data1.map(item => monthNames[item[0] - 1] || `Month ${item[0]}`);



    // Values and totals
    const values1 = Array.from({ length: maxLength }, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({ length: maxLength }, (_, i) => data2[i]?.[1] ?? null);

    const total1 = values1.reduce((sum, val) => sum + (val || 0), 0);
    const total2 = values2.reduce((sum, val) => sum + (val || 0), 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: year1,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: year2,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";
                        return ` (${date}): ${value}`;
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: { size: 10 },
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
            },
        },
    };

    return (
        <div>
            {/* Totals above the chart */}
            <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "1rem" }}>
                <div>
                    <span style={{ color: color1, fontWeight: "bold" }}>●</span> Total: {total1}
                </div>
                <div>
                    <span style={{ color: color2, fontWeight: "bold" }}>●</span> Total: {total2}
                </div>
            </div>

            {/* Chart container */}
            <div style={{ height: "250px" }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};



export const LineChart999 = ({
                                data1,
                                data2,
                                year1,
                                year2,
                                color1 = "#4b7bec",
                                color2 = "#f97316",
                            }) => {
    const maxLength = Math.max(data1.length, data2.length);

    // Helper to get weekday name from date string
// ✅ New - show only date like "06"
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Extract month labels and corresponding values
    const labels = data1.map(item => monthNames[item[0] - 1] || `Month ${item[0]}`);


    const values1 = Array.from({length: maxLength}, (_, i) => data1[i]?.[1] ?? null);
    const values2 = Array.from({length: maxLength}, (_, i) => data2[i]?.[1] ?? null);

    const label1 =
        data1.length > 0 ? `${data1[0][0]} - ${data1[data1.length - 1][0]}` : "Dataset 1";
    const label2 =
        data2.length > 0 ? `${data2[0][0]} - ${data2[data2.length - 1][0]}` : "Dataset 2";

    const chartData = {
        labels,
        datasets: [
            {
                label: year1,
                data: values1,
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderWidth: 2,
            },
            {
                label: year2,
                data: values2,
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {

                        const datasetIndex = context.datasetIndex;
                        const index = context.dataIndex;
                        const value = context.parsed.y;
                        const date =
                            datasetIndex === 0
                                ? data1[index]?.[0] || "-"
                                : data2[index]?.[0] || "-";

                        const seconds = context.parsed.y;
                        const formattedTime = formatSecondsToHHMMSS(seconds);
                        return `${date}: ${formattedTime}`;
                    },
                },
            },
            maintainAspectRatio: false,
        },
        scales: {
            x: {
                ticks: {
                    color: "#666",
                    font: {size: 10},
                    maxRotation: 45,
                    minRotation: 45,
                },
            },
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    callback: (value) => formatSecondsToHHMMSS(value),
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
        },
    };

    return <div style={{height: "250px"}}>
        <Line data={chartData} options={chartOptions}/>
    </div>
};

export const LineChart5 = ({
                               data1,
                               data2,
                               label1,
                               label2,
                               color1 = "#4b7bec",
                               color2 = "#ff6b6b"
                           }) => {
    // Combine all hours (x-axis) from both datasets
    const allHoursSet = new Set([
        ...data1.map((item) => item[0]),
        ...data2.map((item) => item[0]),
    ]);
    const allHours = Array.from(allHoursSet).sort((a, b) => a - b);

    // Map for quick value lookup
    const data1Map = Object.fromEntries(data1);
    const data2Map = Object.fromEntries(data2);

    // Prepare final data arrays
    const labels = allHours.map((hour) => `${hour}:00`);
    const values1 = allHours.map((hour) => data1Map[hour] ?? 0);
    const values2 = allHours.map((hour) => data2Map[hour] ?? 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: label1,
                data: values1,
                fill: false,
                borderColor: color2, // 🔁 was color1
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 3,
                pointBackgroundColor: "#fff",
                pointBorderColor: color2,
            },
            {
                label: label2,
                data: values2,
                fill: true,
                borderColor: color1, // 🔁 was color2
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderDash: [],
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 3,
                pointBackgroundColor: "#fff",
                pointBorderColor: color1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "top",
                labels: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
            },
            tooltip: {
                enabled: true,
                displayColors: false,
                backgroundColor: "#eff6ff",
                titleFont: { size: 13 },
                titleColor: "#6783b8",
                bodyColor: "#9eaecf",
                bodyFont: { size: 12 },
                bodySpacing: 4,
                padding: 10,
                callbacks: {
                    label: function (context) {
                        const seconds = context.parsed.y;
                        const formattedTime = formatSecondsToHHMMSS(seconds);
                        return `Average Time: ${formattedTime}`;
                    },
                },
            },
        },
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    callback: (value) => formatSecondsToHHMMSS(value),
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
            x: {
                ticks: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
                grid: {
                    color: "transparent",
                },
            },
        },
    };

    return <Line className="sales-overview-chart" data={chartData} options={chartOptions} />;
};



export const LineChart7 = ({
                               data1,
                               data2,
                               color1 = "#4b7bec",
                               color2 = "#ff6b6b"
                           }) => {
    const label1 = data1[0]?.label || "Label 1";
    const label2 = data2[0]?.label || "Label 2";

    const value1 = data1[0]?.value || 0;
    const value2 = data2[0]?.value || 0;

    const labels = [`${label1} vs ${label2}`]; // X-axis label

    const chartData = {
        labels,
        datasets: [
            {
                label: label1,
                data: [value1],
                fill: false,
                borderColor: color2,
                backgroundColor: color2,
                tension: 0.4,
                borderDash: [5, 5],
                borderWidth: 2,
                pointRadius: 4,
                pointHoverRadius: 5,
                pointBackgroundColor: "#fff",
                pointBorderColor: color2,
            },
            {
                label: label2,
                data: [value2],
                fill: true,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                tension: 0.4,
                borderDash: [],
                borderWidth: 2,
                pointRadius: 4,
                pointHoverRadius: 5,
                pointBackgroundColor: "#fff",
                pointBorderColor: color1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "top",
                labels: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
            },
            tooltip: {
                enabled: true,
                displayColors: false,
                backgroundColor: "#eff6ff",
                titleFont: { size: 13 },
                titleColor: "#6783b8",
                bodyColor: "#9eaecf",
                bodyFont: { size: 12 },
                bodySpacing: 4,
                padding: 10,
                callbacks: {
                    label: function (context) {
                        const seconds = context.parsed.y;
                        const formattedTime = formatSecondsToHHMMSS(seconds);
                        return `Average Time: ${formattedTime}`;
                    },
                },
            },
        },
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: false,
                ticks: {
                    color: "#9eaecf",
                    callback: (value) => formatSecondsToHHMMSS(value),
                },
                grid: {
                    color: "rgba(82, 100, 132, 0.2)",
                },
            },
            x: {
                ticks: {
                    color: "#9eaecf",
                    font: { size: 12 },
                },
                grid: {
                    color: "transparent",
                },
            },
        },
    };

    return <Line className="sales-overview-chart" data={chartData} options={chartOptions} />;
};



export const LineChart4 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0] + ":00"),
                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                const seconds = context.parsed.y;
                                const formattedTime = formatSecondsToHHMMSS(seconds);
                                return `Average Time: ${formattedTime}`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            color: "#9eaecf",
                            callback: (value) => formatSecondsToHHMMSS(value),
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                        },
                    },
                },
            }}
        />
    );
};


export const LineChart1 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0]),
                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                        pointRadius: 3,
                        pointHoverRadius: 5,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: "#eff6ff",
                        titleFont: {
                            size: 11,
                        },
                        titleColor: "#6783b8",
                        bodyColor: "#9eaecf",
                        bodyFont: {
                            size: 10,
                        },
                        bodySpacing: 3,
                        padding: 8,
                        callbacks: {
                            label: function (context) {
                                return `${context.parsed.y} Visitors`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: "#9eaecf",
                            font: {
                                size: 11,
                            },
                            callback: (value) => `${value}`,
                            padding: 10,
                        },
                        grid: {
                            tickMarkLength: 0,
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                            font: {
                                size: 9,
                            },
                            padding: 10,
                        },
                        grid: {
                            color: "transparent",
                            tickMarkLength: 0,
                        },
                    },
                },
            }}
        />
    );
};


export const LineChart2 = ({ chartData }) => {
    return (
        <Line
            className="sales-overview-chart"
            data={{
                labels: chartData.map((item) => item[0]),
                datasets: [
                    {
                        label: "Visitors",
                        data: chartData.map((item) => item[1]),
                        fill: true,
                        backgroundColor: "rgba(99, 132, 255, 0.2)",
                        borderColor: "#4b7bec",
                        tension: 0.4,
                        pointRadius: 3,
                        pointHoverRadius: 5,
                    },
                ],
            }}
            options={{
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: "#eff6ff",
                        titleFont: {
                            size: 11,
                        },
                        titleColor: "#6783b8",
                        bodyColor: "#9eaecf",
                        bodyFont: {
                            size: 10,
                        },
                        bodySpacing: 3,
                        padding: 8,
                        callbacks: {
                            label: function (context) {
                                return `${context.parsed.y} Second`;
                            },
                        },
                    },
                },
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: "#9eaecf",
                            font: {
                                size: 11,
                            },
                            callback: (value) => `${value}`,
                            padding: 10,
                        },
                        grid: {
                            tickMarkLength: 0,
                        },
                    },
                    x: {
                        ticks: {
                            color: "#9eaecf",
                            font: {
                                size: 9,
                            },
                            padding: 10,
                        },
                        grid: {
                            color: "transparent",
                            tickMarkLength: 0,
                        },
                    },
                },
            }}
        />
    );
};

export const DoubleBar = ({ state }) => {
  let object;
  const setData = (state) => {
    switch (state) {
      case "set2":
        object = orderOverviewSet2;
        break;
      case "set3":
        object = orderOverviewSet3;
        break;
      default:
        object = orderOverviewSet1;
    }
    return object;
  };
  return (
    <Bar
      className="chartjs-render-monitor"
      data={setData(state)}
      options={{
        plugins: {
          legend: {
              display: false,
          },
          tooltip: {
              enabled: true,
              displayColors: false,
              backgroundColor: "#eff6ff",
              titleFont: {
                size: '13px',
              },
              titleColor: "#6783b8",
              titleMarginBottom: 6,
              bodyColor: "#9eaecf",
              bodyFont: {
                size: '12px',
              },
              bodySpacing: 4,
              padding: 10,
              footerMarginTop: 0,
          },
        },
        maintainAspectRatio: false,
        scales: {
          y:{
              display: true,
              ticks: {
                beginAtZero: true,
                color:"#9eaecf", 
                font: {
                  size: '11px',
                },
                padding: 10,
                callback: function (value, index, values) {
                  return "$ " + value;
                },
                min: 100,
                max: 5000,
                stepSize: 1200,
              },
              grid: {
                tickMarkLength: 0,
              },
          },
          x:{
              display: true,
              ticks: {
                color:"#9eaecf", 
                font: {
                  size: '9px',
                },
                source: "auto",
                padding: 10,
                stepSize: 2400,
              },
              grid: {
                color: "transparent",
                tickMarkLength: 0,
                zeroLineColor: "transparent",
              },
          },
        },
      }}
    />
  );
};

export const HorizontalBarChart = ({ state }) => {
  const [data, setData] = useState(coinOverview);
  useEffect(() => {
    let object;
    if (state === "day") {
      object = coinOverviewSet3;
    } else if (state === "month") {
      object = coinOverviewSet2;
    } else {
      object = coinOverviewSet1;
    }
    setData(object);
  }, [state]);
  return (
    <Bar
      data={data}
      className="coin-overview-chart"
      options={{
        plugins: {
          legend: {
              display: false,
          },
          tooltip: {
              enabled: true,
              displayColors: false,
              backgroundColor: "#eff6ff",
              titleFont: {
                size: '13px',
              },
              titleColor: "#6783b8",
              titleMarginBottom: 6,
              bodyColor: "#9eaecf",
              bodyFont: {
                size: '12px',
              },
              bodySpacing: 4,
              padding: 10,
              footerMarginTop: 0,
          },
        },
        indexAxis: "y",
        maintainAspectRatio: false,
        scales: {
          y: {
              display: false,
              stacked: true,
              ticks: {
                beginAtZero: true,
                padding: 0,
              },
              grid: {
                tickMarkLength: 0,
              },
          },
          x:{
              display: false,
              stacked: true,
              ticks: {
                color:"#9eaecf", 
                font: {
                  size: '9px',
                },
                source: "auto",
                padding: 0,
              },
              grid: {
                color: "transparent",
                tickMarkLength: 0,
                zeroLineColor: "transparent",
              },
          },
        },
      }}
    />
  );
};

export const StackedBarChart = ({ state }) => {
  const [data, setData] = useState(userActivity);
  useEffect(() => {
    let object;
    if (state === "day") {
      object = userActivitySet2;
    } else if (state === "month") {
      object = userActivitySet3;
    } else {
      object = userActivitySet4;
    }
    setData(object);
  }, [state]);
  return (
    <Bar
      className="usera-activity-chart"
      data={data}
      options={{
        plugins: {
          legend: {
              display: false,
          },
          tooltip: {
              enabled: true,
              displayColors: false,
              backgroundColor: "#eff6ff",
              titleFont: {
                size: '13px',
              },
              titleColor: "#6783b8",
              titleMarginBottom: 6,
              bodyColor: "#9eaecf",
              bodyFont: {
                size: '12px',
              },
              bodySpacing: 4,
              padding: 10,
              footerMarginTop: 0,
          },
        },
        maintainAspectRatio: false,
        scales: {
          y: {
              display: false,
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
          },
          x: {
              display: false,
              stacked: true,
          },
        },
      }}
    />
  );
};
